module.exports = __webpack_public_path__ + "static/media/utilities.034b60b9.svg";